import env from '@/env';
import { DwsDok } from '@/common';

export const downloadCertificateFromDws = async ({
  dok,
  filename,
}: {
  dok: DwsDok;
  filename: string;
}) => {
  fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/download/portal/osv/doc?documentId=${dok.docindexId}&filename=${dok.filename}&originaldocumentId=${dok.docindexId}&filename=${dok.originalfilename}&extension=${dok.extension}&dsdoctype=${dok.dsdoctype}&datum=${dok.date}&cdnUrl=false`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  )
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}.${dok.extension}`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();
    });
};
